/**
 * Scoped loggers for VideoStudioApp.
 *
 * Correlate everything with { opId, jobId, spaceId, windowId, projectId,
 * clipId } so a single grep across the client + backend + tool-runtime logs
 * reconstructs an entire AI op or ingest flow.
 */

import { createFileLogger } from '../../../utils/logger';

export const vsLog = createFileLogger('VIDEO_STUDIO', { enabled: true });
export const vsLogYjs = createFileLogger('VIDEO_STUDIO_YJS', { enabled: true });
export const vsLogJobs = createFileLogger('VIDEO_STUDIO_JOBS', { enabled: true });
export const vsLogUpload = createFileLogger('VIDEO_STUDIO_UPLOAD', { enabled: true });
export const vsLogPlayback = createFileLogger('VIDEO_STUDIO_PLAYBACK', { enabled: false });
